export default {
  name: {
    id: 'rm_metal_antimony_name',
    defaultMessage: 'Antimony',
  },
  smartphoneLabel: {
    id: 'rm_metal_antimony_smartphone_label',
    defaultMessage: 'Trace (invisible to the naked eye)',
  },
  whatItDoesText: {
    id: 'rm_metal_antimony_what_it_does',
    defaultMessage:
      'Antimony trioxide is added to circuit boards, plastics and cable coverings to help stop them from catching fire. In smartphone chips, tiny, precisely controlled amounts of antimony are added to silicon as a dopant. This shapes how electricity flows through the transistors, allowing them to switch and process information.',
  },
  extractionText1: {
    id: 'rm_metal_antimony_extraction_p1',
    defaultMessage:
      'Antimony is mainly extracted from stibnite, a sulfide ore. The ore is crushed and concentrated by flotation, producing a concentrate containing 60% to 68% antimony. It is then heated to remove sulfur and produce antimony oxide. Further reduction and melting produces antimony metal. Oxide ores are processed by gravity separation before being melted.',
  },
  quickFactText: {
    id: 'rm_metal_antimony_quick_fact',
    defaultMessage:
      'Antimony helps stop electronics from catching fire, but its supply is a burning issue. Three countries account for about 90% of global antimony mine production, and recent restrictions have raised concerns about shortages in Europe.',
  },
  envSummaryText: {
    id: 'rm_metal_antimony_env_summary',
    defaultMessage:
      'Antimony released through mining and processing can accumulate in soil and spread to nearby water. It may remain bound to soil for some time, but changes in local conditions can release it again. At high concentrations, it can harm plants and soil microorganisms. It can also enter crops and move through food chains.',
  },
  envWaterText: {
    id: 'rm_metal_antimony_env_water_text',
    defaultMessage:
      'Antimony can enter water when sulfide ores weather or when rainwater and drainage leach mining waste. Although much of it binds to soil and sediment, its mobility varies with acidity, oxidation conditions and mineral composition. Mobile antimony can therefore spread from mine sites into surrounding soils, sediments and aquatic environments.',
  },
  envSoilText: {
    id: 'rm_metal_antimony_env_soil_text',
    defaultMessage:
      'Antimony from mining, ore storage, transport, smelting and wastewater can accumulate in nearby soils. Clay and iron-rich minerals can retain it, limiting its movement, but this does not eliminate the contamination.',
  },
  envBiodiversityText: {
    id: 'rm_metal_antimony_env_biodiversity_text',
    defaultMessage:
      'High concentrations of antimony can harm plants and soil organisms. In heavily polluted mining soils, bacterial abundance and diversity are lower. Antimony can also accumulate in plant roots and shoots and enter crops, creating a pathway from contaminated soil into food chains.',
  },
  humanSummaryText: {
    id: 'rm_metal_antimony_human_summary',
    defaultMessage:
      'Near an active antimony mine in Hunan, China, antimony concentrations exceeded reference levels in drinking water, food and residents’ biological samples. Drinking water was the main exposure route, and estimated daily intake reached up to 30 times the U.S. oral reference dose. Workers who inhale antimony trioxide may also face increased lung cancer risks.',
  },
  geoSummaryText: {
    id: 'rm_metal_antimony_geo_summary',
    defaultMessage:
      'Antimony supply is highly concentrated in the hands of one country, China, making it vulnerable to political decisions. China introduced export restrictions and bans on several key minerals, including antimony, in late 2024. These measures raised concerns about shortages and triggered price surges, showing how China’s market dominance can become political leverage over semiconductor, defence and other supply chains.',
  },
  geoDugText: {
    id: 'rm_metal_antimony_geo_dug_text',
    defaultMessage:
      'China mined an estimated 60,000 tonnes of antimony in 2024, compared with 17,000 tonnes in Tajikistan and 13,000 tonnes in Russia. Together, these three countries accounted for approximately 90% of global production.',
  },
  geoProcessedText: {
    id: 'rm_metal_antimony_geo_processed_text',
    defaultMessage:
      'China dominates the refined antimony supply chain and is the main producer of antimony trioxide and antimony metal. It accounts for around 74% of the antimony market, highlighting the concentration of refined supply.',
  },
  geoLeverageText: {
    id: 'rm_metal_antimony_geo_leverage_text',
    defaultMessage:
      'China introduced export licensing for antimony in September 2024, followed by a complete ban on exports to the United States in December. The European Union has been particularly affected: no antimony exports have reached the region since October 2024. This has raised shortage concerns across the EU’s defence, energy and automotive industries, prompting a search for alternative suppliers. Data show that antimony prices rose sharply after the restrictions, illustrating how quickly export controls can affect markets.',
  },
  supplySummaryText: {
    id: 'rm_metal_antimony_supply_summary',
    defaultMessage:
      'Antimony supply is highly concentrated and vulnerable to political decisions. Its price is also among the most volatile of all strategic minerals, making supply disruption an immediate risk rather than a distant possibility.',
  },
  supplyReservesText: {
    id: 'rm_metal_antimony_supply_reserves_text',
    defaultMessage:
      'More than two million tonnes of antimony reserves have been identified worldwide. At current production levels, economically recoverable reserves could last only five years. This does not mean that antimony will disappear, since reserves change with prices, discoveries, demand and technology.',
  },
  supplyDemandText: {
    id: 'rm_metal_antimony_supply_demand_text',
    defaultMessage:
      'Global demand is expected to remain broadly stable in the near term, but new semiconductor applications could drive growth. A projection for France illustrates the potential scale of this trend: demand for antimony in digital equipment could rise by 30% by 2030 and 267% by 2050, mainly due to network equipment, virtual-reality devices and data centres.',
  },
  recyclingSummaryText: {
    id: 'rm_metal_antimony_recycling_summary',
    defaultMessage:
      'Antimony’s overall recycling rate is driven mainly by well-collected batteries. Digital equipment tells a different story. Antimony is not recovered from separated plastic components, and recovery from cable coverings has not been demonstrated. Research is exploring recovery from shredded electronic waste and incineration residues, but low concentrations, mixed materials and limited demand for recycled antimony remain major barriers.',
  },
} as const
